var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-w pd20"},[_c('div',[_c('ve-pie',{attrs:{"data":_vm.chartPieData}})],1),_c('div',{staticClass:"mt20"},[_c('ve-line',{attrs:{"data":_vm.chartLineData}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }